
export class MailCriteria {
falseFlags: string[];
folder: string;
trueFlags: string[];
}

